import React from "react";
import copyToClipboard from "copy-to-clipboard";
import { useFetcher } from "react-router-dom";
import { CopyIcon } from "../../images";
import { Spinner } from "./Spinner";
import { successNotify } from "../notify/toastify";
import { convertToPersianNumber } from "../Demo/utils/functions";

export const CopyButton = ({ requestId }) => {
  const [isWaitingToCopy, setIsWaitingToCopy] = React.useState(false);
  const fetcher = useFetcher();

  let data = null;

  if (fetcher.data) {
    const responseData = fetcher.data;
    data = responseData.segments;
  }

  const speakerLabel = (speaker) => {
    if (!speaker) return "";
    if (speaker.startsWith("SPEAKER_") || speaker.startsWith("speaker_")) {
      const n = parseInt(speaker.split("_")[1], 10);
      if (!Number.isNaN(n)) {
        return `گوینده ${convertToPersianNumber(n + 1)}: `;
      }
    }
    return `${speaker}: `;
  };

  React.useEffect(() => {
    if (isWaitingToCopy && data) {
      const textToCopy = data
        .filter((s) => s && (s.text || s.speaker))
        .map((s) => {
          const text = (s.text || "").trim();
          if (!text) return "";
          return `${speakerLabel(s.speaker)}${text}`;
        })
        .filter(Boolean)
        .join("\n");
      copyToClipboard(textToCopy);
      successNotify({ text: "متن با موفقیت کپی شد" });
      setIsWaitingToCopy(false);
    }
  }, [data, isWaitingToCopy]);

  const handleCopy = async () => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(`/archive/requests/${requestId}`);
    }
    setIsWaitingToCopy(true);
  };

  return (
    <>
      {isWaitingToCopy && !data ? (
        <Spinner width={25} height={27.09} innerSize={15} color="#c1c1c1" />
      ) : (
        <button className="action-icon-wrapper" onClick={handleCopy}>
          <CopyIcon width="17" height="17" color="#8F8F8F" />
        </button>
      )}
    </>
  );
};
